import { render } from "./ValueYourTrade.vue?vue&type=template&id=0a32b872&lang=true"
import script from "./ValueYourTrade.vue?vue&type=script&lang=js"
export * from "./ValueYourTrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__